var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailBlackIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07187 20.2034C3.44216 20.2034 2.90556 19.9817 2.46207 19.5382C2.01861 19.0947 1.79688 18.5581 1.79688 17.9284V6.0719C1.79688 5.44218 2.01862 4.90558 2.46213 4.4621C2.90559 4.01862 3.44218 3.79688 4.0719 3.79688H19.9284C20.5581 3.79688 21.0947 4.01862 21.5382 4.4621C21.9817 4.90558 22.2034 5.44218 22.2034 6.0719V17.9284C22.2034 18.5581 21.9817 19.0947 21.5382 19.5382C21.0947 19.9817 20.5581 20.2034 19.9284 20.2034H4.07187ZM12.0001 13.2572L4.07187 8.25723V17.9284H19.9284V8.25723L12.0001 13.2572ZM12.0001 11.0719L19.9284 6.0719H4.07187L12.0001 11.0719ZM4.07187 8.25723V6.0719V17.9284V8.25723Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBlackIcon);
export default __webpack_public_path__ + "static/media/EmailBlackIcon.51b654533d6e29fdb55786c62cea0a92.svg";
export { ForwardRef as ReactComponent };